import React from 'react';

import ContentCard from './ContentCard';

const ContentCardGrid = ({
  projects,
  handleActiveProject,
  cardsAction,
  isFeatured,
  navigate,
  searchParameters,
}: {
  projects: Project[];
  handleActiveProject: HandleActiveProject;
  cardsAction: string;
  isFeatured: boolean;
  navigate: Navigate;
  searchParameters: URLSearchParams;
}) => {
  const contentCards = projects.map((project) => (
    <ContentCard
      key={project.title}
      cardAction={cardsAction}
      project={project}
      isFeatured={isFeatured}
      handleActiveProject={handleActiveProject}
      navigate={navigate}
      searchParameters={searchParameters}
    />
  ));

  return (
    <div className={`card-grid ${!isFeatured && 'dashboard-card-grid'}`}>
      {contentCards}
    </div>
  );
};

export default ContentCardGrid;
